//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { shallowEqual, useSelector } from 'react-redux'
//  ----------------------------------------------------------------------------
//  Selectors
//  ----------------------------------------------------------------------------
//  -- Examples data ------------------
const selectore = (state) => state.whats_new;
//  -- Examples array selector --------
export const useWhatsNew = () =>{
    const selectedData = useSelector(selectore, shallowEqual)
    return selectedData;
}